import React from 'react';

import { PillsInputProps } from './PillsInput';

export const InputContext = React.createContext<PillsInputProps>({});
